import React from 'react';

import NewLabelFilterWrap from 'components/molecules/NewLabelFilterWrap';
import MbPopper from 'components/molecules/MbPopper';

/**
 * 테이블 popover 되는 필터 wrapper
 * @param {json} param0
 */
export default class NewPopoverWrap extends React.Component {
  constructor(props) {
    super(props);
    this.anchorRef = React.createRef();
  }

  handleClose = (event) => {
    const { anchorRef } = this;
    const { onClick } = this.props;
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    } else {
      onClick();
    }
  };

  render() {
    const { anchorRef, handleClose } = this;
    const {
      open,
      selectedLabel,
      className,
      label,
      filtered,
      id,
      filterList,
      onClick,
      error,
      popoverWidth,
      popoverMaxWidth,
      popoverHeight,
      style,
    } = this.props;

    return (
      <>
        <NewLabelFilterWrap
          className={className}
          label={label}
          filtered={filtered}
          onClick={onClick}
          anchorRef={anchorRef}
          style={style}
          error={error}
        >
          {selectedLabel}
        </NewLabelFilterWrap>
        <MbPopper
          open={open}
          anchorRef={anchorRef}
          onClickAway={open ? handleClose : (f) => f}
          id={id}
          popoverWidth={popoverWidth}
          popoverMaxWidth={popoverMaxWidth}
          popoverHeight={popoverHeight}
        >
          {filterList}
        </MbPopper>
      </>
    );
  }
}
